module.exports = (parcelRequire.load("7ctXl")).then(() => parcelRequire('01Gfi'));